import React from 'react';
import { Table } from 'antd';
import trans from '../../../translations.json';
import ReducedData from '../../../reducedData.json';
import dict from '../../../dictionary';
import { dateFormater, percentChangeCalc } from '../../utils';
import Icon from '../../../ds/icons/svg/ontario-icon-dropdown-arrow.svg';

let phuNum = {};
  ReducedData.dataTesting.forEach(item => {
    if (!Object.keys(phuNum).includes(item.PHU_num)) {
      for (var key in dict.PHUs) {
        if (dict.PHUs[key] === item.PHU_name) {
          phuNum[item.PHU_num] = key;
        
      }
    }
  }
});
phuNum[2268] = 'Windsor-Essex County Health Unit';

class TestsByPhuDailyTable extends React.Component {
  state = {
    data: undefined,
    keys: Object.keys(ReducedData.dataPHU),
    selection: this.props.selected,
  };

  render() {
    let name = this.state.selection;

    let dataFiltered;
    var TestData = Object.values(ReducedData.dataTesting);
    let test = TestData.filter(
      (item) => phuNum[item.PHU_num] === name,
    );
    dataFiltered = test
      .map((item, z) => {
        return [
          item[dict.DATE],
          parseFloat(item[dict.testingAvg].replace(/,/g, '')),
          (item[dict.percentPositiveAvg] * 100).toFixed(2),
        ];
      })
      .filter((item) => item);
    dataFiltered = dataFiltered
      .sort((a, b) => new Date(b[0]) - new Date(a[0]))
      .reverse();
    let tableData = dataFiltered
      .map((item, z) => {
        var yesterdayTestingDaily = dataFiltered[z - 1]
          ? dataFiltered[z - 1][1]
          : 0;
        var todayTestingDaily = item[1];
        var yesterdayPercentPositiveDaily = dataFiltered[z - 1]
          ? dataFiltered[z - 1][2]
          : 0;
        var todayPercentPositiveDaily = item[2];
        return {
          index: z,
          date: dateFormater(item[0]),
          testsDoneYday: todayTestingDaily.toLocaleString(),
          precentChange:
            this.props.graphType === 'testing-volumes'
              ? percentChangeCalc(
                  todayTestingDaily,
                  yesterdayTestingDaily,
                  2,
                )
              : percentChangeCalc(
                  todayPercentPositiveDaily,
                  yesterdayPercentPositiveDaily,
                  2,
                ),
          percentConfirmedPositive: todayPercentPositiveDaily + ' %',
        };
      })
      .reverse();
    tableData.pop();

    const columns = [
      {
        title: trans.date[this.props.lang],
        dataIndex: 'date',
        key: 'date',
        width: '20%',
      },
      {
        title:
          this.props.graphType === 'testing-volumes'
            ? trans.testing.testsDoneYesterday[this.props.lang]
            : trans.testing.titleC[this.props.lang],
        dataIndex:
          this.props.graphType === 'testing-volumes'
            ? 'testsDoneYday'
            : 'percentConfirmedPositive',
        key:
          this.props.graphType === 'testing-volumes'
            ? 'testsDoneYday'
            : 'percentConfirmedPositive',
        width: '30%',
      },
      {
        title: trans.general.precentChange[this.props.lang],
        dataIndex: 'precentChange',
        key: 'precentChange',
        width: '30%',
        render: (text, record) => {
          if (Number(text) > 0) {
            return (
              <span>
                <img
                  alt={trans.general.increase[this.props.lang]}
                  style={{ transform: 'rotate(180deg)' }}
                  src={Icon}
                />
                {text} %
              </span>
            );
          } else if (Number(text) < 0) {
            return (
              <span>
                <img
                  alt={trans.general.decrease[this.props.lang]}
                  src={Icon}
                />
                {Math.abs(Number(text))} %
              </span>
            );
          } else {
            return <span> ― </span>;
          }
        },
      },
    ];
    return (
      <>
        <Table
          pagination={{ showSizeChanger: false }}
          columns={columns}
          dataSource={tableData}
          scroll={{ x: 300 }}
          locale={{
            emptyText: trans.viewModes.noDataPHU[this.props.lang],
          }}
        />
      </>
    );
  }
}

export default TestsByPhuDailyTable;
